module.exports = __webpack_public_path__ + "img/pic-04.7d898aaa.png";